import { Identifier } from 'dnd-core';
import { XYCoord } from 'react-dnd';

import { ItemTypes } from 'dashboard/apps/DashboardLayoutEditor/constants';
import {
  ScreenEditorComponentItem,
  ScreenEditorDraggableItemTypes,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/types';
import { DraggedItem } from 'dashboard/apps/InquiryTemplateEditor/WorkflowTree/WorkflowTreeDragAndDropUtils';
import { UiComponentConfigType } from 'lib/interfaces/ui-components';

export interface ModuleDragPreviewUseDragLayer {
  currentClientOffset: XYCoord;
  currentOffset: XYCoord;
  isDragging: boolean;
  itemType: Identifier;
}

export function isModuleDragPreviewUseDragLayer(
  collectedProps: GlobalUseDragLayer,
): collectedProps is ModuleDragPreviewUseDragLayer {
  return (
    'currentClientOffset' in collectedProps &&
    'currentOffset' in collectedProps &&
    'isDragging' in collectedProps &&
    'itemType' in collectedProps &&
    collectedProps.itemType === ItemTypes.LibraryComponent
  );
}

export interface FlowEditorComponentEditorUseDragLayer {
  item: ScreenEditorComponentItem | null;
  isDragging: boolean;
  currentOffset: XYCoord | null;
}

export function isFlowEditorComponentEditorUseDragLayer(
  collectedProps: GlobalUseDragLayer,
): collectedProps is FlowEditorComponentEditorUseDragLayer {
  const item: ScreenEditorComponentItem | DraggedItem | null =
    'item' in collectedProps && collectedProps.item ? collectedProps.item : null;

  const hasItem = !!item;
  const hasIsDragging = 'isDragging' in collectedProps;
  const hasCurrentOffset = 'currentOffset' in collectedProps;
  const hasItemType = 'itemType' in collectedProps;
  const isComponentType =
    hasItemType && collectedProps.itemType === ScreenEditorDraggableItemTypes.COMPONENT;
  const hasItemTypeInUiComponentConfig =
    hasItem && 'type' in item && item.type in UiComponentConfigType;

  return (
    hasItem &&
    hasIsDragging &&
    hasCurrentOffset &&
    (isComponentType || hasItemTypeInUiComponentConfig)
  );
}

export interface WorkflowTreeUseDragLayer {
  currentPos: XYCoord;
  isDragging: boolean;
  item: DraggedItem;
}

export function isWorkflowTreeUseDragLayer(
  collectedProps: GlobalUseDragLayer,
): collectedProps is WorkflowTreeUseDragLayer {
  return (
    ('currentPos' in collectedProps &&
      'isDragging' in collectedProps &&
      'item' in collectedProps &&
      collectedProps.item &&
      'token' in collectedProps.item) ??
    false
  );
}

export interface FlowCanvasUseDragLayer {
  draggedItem: { id: string };
  draggedPos: XYCoord;
  draggingInProgress: boolean;
}

export function isFlowCanvasUseDragLayer(
  collectedProps: GlobalUseDragLayer,
): collectedProps is FlowCanvasUseDragLayer {
  return (
    ('draggedItem' in collectedProps &&
      'draggedPos' in collectedProps &&
      'draggingInProgress' in collectedProps &&
      collectedProps.draggedItem &&
      'id' in collectedProps.draggedItem) ??
    false
  );
}
